import React, { useState } from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import {
  ChevronDownIcon,
  EllipsisVerticalIcon,
} from "@heroicons/react/24/outline";
import { useRequestApproval, useRequestReject } from "../custom-hooks/queries";
import Notification from "./Notification";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ModalWithTextBox from "./ModalWithTextBox";
import { useDispatch } from "react-redux";
import { setDrawer } from "../redux-store/features/layoutSlice";
import { useUserRole } from "../utils/helperMethods";
import { Icon } from "@iconify/react/dist/iconify.js";
import NotificationModal from "./NotificationModal";

const DropdownMenu = ({
  buttonLabel,
  menuItems,
  requestId,
  refetch,
  id,
  approve,
  reject,
  approveError,
  rejectError,
  downloadFile,
  approveIsError,
  rejectIsError,
  documentId,
  navigation,
  border,
  icon,
  docStatus,
  manageParticipants,
  count,
  navigateToParticipants,
}) => {
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const userRole = useUserRole();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleManage = (label) => {
    if (label.toLowerCase() === "release") {
      approve(id, {
        onSuccess: () => {
          setShow(true);
          setMessage("The Assessment request has been successfully approved.");
          setStatus("success");
          refetch();
        },
        onError: () => {
          setMessage(approveError?.response?.data.message);
          setShow(true);
          setStatus("error");
        },
      });
    } else if (label.toLowerCase() === "view") {
      if (pathname === "/Backend/Assessment/Request/History") {
        navigate(navigation, { state: { docStatus } });
      } else {
        navigate(navigation);
      }
    } else if (label.toLowerCase() === "manage participants") {
      navigate(navigateToParticipants);
    } else if (pathname === "/Backend/Assessment/History") {
      dispatch(setDrawer(true));
      setOpen(true);
    } else if (label.toLowerCase() === "reject") {
      try {
        setOpen(true);
      } catch (e) {}
    } else if (label.toLowerCase() === "download") {
      downloadFile(documentId);
    }
  };
  const handleItemClick = (item) => {
    if (item.action) {
      item.action(); // Trigger the action if defined
    } else if (item.href) {
      window.location.href = item.href; // Fallback to href if no action
    }
  };

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <MenuButton
          className={`inline-flex items-center justify-center rounded-md p-1.5 text-gray-400 hover:text-gray-500 hover:bg-gray-50 focus:outline-none ${border}`}
        >
          <span className="sr-only">Open options</span>
          <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
        </MenuButton>
      </div>

      <MenuItems
        anchor="bottom end"
        portal
        className="z-[100] mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <div className="py-1">
          {menuItems.map((item, index) => {
            if (
              count === 0 &&
              item.label.toLowerCase() === "manage participants"
            )
              return null;
            return (
              <MenuItem key={index}>
                {({ active }) => (
                  <div
                    onClick={(e) => {
                      handleManage(item.label);
                    }}
                    className={`block px-4 py-2 text-sm border border-gray-300 cursor-pointer ${
                      active ? "bg-gray-100 text-gray-900" : "text-gray-700"
                    }`}
                  >
                    <button onClick={() => handleItemClick(item)}>
                      {count > 0 ? item.label : item.label}
                    </button>
                  </div>
                )}
              </MenuItem>
            );
          })}
        </div>
      </MenuItems>
      <NotificationModal
        open={show}
        setOpen={setShow}
        desc={message}
        title={approveError || rejectIsError ? "Error" : "Success"}
        error={approveError || rejectIsError}
      />
      <ModalWithTextBox
        open={open}
        setOpen={setOpen}
        onClick={reject}
        id={id}
        refetch={refetch}
        rejectError={rejectError}
      />
    </Menu>
  );
};

export default DropdownMenu;
